import * as S from './styles.ts';

interface ISliderLabelProps {
  label?: number | string;
  left?: number;
  onClick: (e: any) => void;
}

const SliderLabel = ({ label, left, onClick }: ISliderLabelProps) => {
  return (
    <S.SliderLabelWrapper
      $left={left}
      onClick={onClick}
      aria-label={`Button to move slider to ${label} users`}
      tabIndex={label === undefined ? -1 : 0}
    >
      {label}
    </S.SliderLabelWrapper>
  );
};

export default SliderLabel;
